// extracted by mini-css-extract-plugin
export default {"datepickerwarapper":"AdminEditCustomerForm_datepickerwarapper_tAqWQ","datepickerinput":"AdminEditCustomerForm_datepickerinput_RyZQa","invalid":"AdminEditCustomerForm_invalid_jxHhi"};